module.exports = __webpack_public_path__ + "img/TSN_phone_01.66db5014.png";